import type { AiChatMessagePart } from '../../ai-chat-types';

import { isImageMediaType } from './is-image-media-type';

export const getImageSrcFromPart = (part: AiChatMessagePart): string | undefined => {
  if (part.type === 'image' && part.image) {
    return part.image;
  }

  if (part.type === 'file' && part.url && isImageMediaType(part.mediaType)) {
    return part.url;
  }

  return undefined;
};

export const isImagePart = (part: AiChatMessagePart): boolean => {
  return getImageSrcFromPart(part) != null;
};
